import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enTranslation from './translations/en'
import frTranslation from './translations/fr'
import ptTranslation from './translations/pt'

i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        debug: true,
        fallbackLng: 'en',
        fallbackNS: 'global',
        // React escapes rendered text itself; i18next's own escaping turned "Team F/F" into "Team F&#x2F;F"
        interpolation: { escapeValue: false },
        resources: {
            en: enTranslation,
            fr: frTranslation,
            pt: ptTranslation,
        },
    })

/**
 * generate a condense translations json for validation
 */
// function tsCondense(translations) {
//     console.log('-----translations', translations)
//     const languages = Object.entries(translations)

//     const result = {}

//     for (let i = 0; i < languages.length; i++) {
//         // lng : en | fr | pt
//         const [lng, namespacesObject] = languages[i]

//         const namespaces = Object.entries(namespacesObject)
//         // console.log('--level 1', { lng })

//         for (let j = 0; j < namespaces.length; j++) {
//             // namespace : global | ...
//             const [namespace, valuesObject] = namespaces[j]

//             if (!result[namespace]) {
//                 result[namespace] = {}
//             }

//             const values = Object.entries(valuesObject)
//             // console.log('--level 2', { lng, namespace, values })

//             for (let k = 0; k < values.length; k++) {
//                 // key: "Oops, an error occurred !"
//                 // value: "Oups, une erreur s'est produite !"
//                 const [key, value] = values[k]
//                 // console.log('--level 3', { lng, namespace, key, value })
//                 if (!result[namespace][key]) {
//                     result[namespace][key] = { [lng]: value }
//                 } else {
//                     result[namespace][key] = { ...result[namespace][key], [lng]: value }
//                 }
//             }
//         }
//     }
//     console.log('result', result)
// }

// tsCondense({
//     en: enTranslation,
//     fr: frTranslation,
//     pt: ptTranslation,
// })
